import React, { lazy, Suspense } from "react"
import PropTypes from "prop-types"
import { Flex, Spin } from "antd"

// react-pdf brings pdf.js (~0.3 MB), so the viewer loads the first time a PDF is shown
const PdfDocument = lazy(() => import("./PdfDocument"))

const PdfViewer = ({ url, height = 400 }) => (
  <Suspense
    fallback={
      <Flex justify="center" align="center" style={{ height }}>
        <Spin />
      </Flex>
    }
  >
    <PdfDocument url={url} height={height} />
  </Suspense>
)

PdfViewer.propTypes = {
  url: PropTypes.string.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default PdfViewer
